// extracted by mini-css-extract-plugin
export default {"_":"info____3vmnL","link":"info_link__ZX4dj"};